export function getWithMiddlename() {
  return (process.env['NEXT_PUBLIC_MIDDLENAME_IN_FORMS'] ?? '') === 'true';
}
